import React from'react';
import PropTypes from'prop-types';
import{intl,Spinner}from'ulta-components';
import messages from'./LoadingSpinner.messages';

var LoadingSpinner=function LoadingSpinner(_ref){var isLoading=_ref.isLoading;
if(!isLoading){
return null;
}

return(
React.createElement('div',{className:'text-center'},
React.createElement(Spinner,{message:intl.formatMessage(messages.loading_message)})));

};

LoadingSpinner.propTypes={
isLoading:PropTypes.bool};


LoadingSpinner.defaultProps={
isLoading:false};


export default LoadingSpinner;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0xvYWRpbmdTcGlubmVyL0xvYWRpbmdTcGlubmVyLmpzeCJdLCJuYW1lcyI6WyJSZWFjdCIsIlByb3BUeXBlcyIsImludGwiLCJTcGlubmVyIiwibWVzc2FnZXMiLCJMb2FkaW5nU3Bpbm5lciIsImlzTG9hZGluZyIsImZvcm1hdE1lc3NhZ2UiLCJsb2FkaW5nX21lc3NhZ2UiLCJwcm9wVHlwZXMiLCJib29sIiwiZGVmYXVsdFByb3BzIl0sIm1hcHBpbmdzIjoiQUFBQSxNQUFPQSxNQUFQLEtBQWtCLE9BQWxCO0FBQ0EsTUFBT0MsVUFBUCxLQUFzQixZQUF0QjtBQUNBLE9BQVNDLElBQVQsQ0FBZUMsT0FBZixLQUE4QixpQkFBOUI7QUFDQSxNQUFPQyxTQUFQLEtBQXFCLDJCQUFyQjs7QUFFQSxHQUFNQyxnQkFBaUIsUUFBakJBLGVBQWlCLE1BQW1CLElBQWhCQyxVQUFnQixNQUFoQkEsU0FBZ0I7QUFDeEMsR0FBSSxDQUFDQSxTQUFMLENBQWdCO0FBQ2QsTUFBTyxLQUFQO0FBQ0Q7O0FBRUQ7QUFDRSwyQkFBSyxVQUFVLGFBQWY7QUFDRSxvQkFBQyxPQUFELEVBQVMsUUFBU0osS0FBS0ssYUFBTCxDQUFtQkgsU0FBU0ksZUFBNUIsQ0FBbEIsRUFERixDQURGOztBQUlELENBVEQ7O0FBV0FILGVBQWVJLFNBQWYsQ0FBMkI7QUFDekJILFVBQVdMLFVBQVVTLElBREksQ0FBM0I7OztBQUlBTCxlQUFlTSxZQUFmLENBQThCO0FBQzVCTCxVQUFXLEtBRGlCLENBQTlCOzs7QUFJQSxjQUFlRCxlQUFmIiwiZmlsZSI6IkxvYWRpbmdTcGlubmVyLmpzeCIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBpbnRsLCBTcGlubmVyIH0gZnJvbSAndWx0YS1jb21wb25lbnRzJztcbmltcG9ydCBtZXNzYWdlcyBmcm9tICcuL0xvYWRpbmdTcGlubmVyLm1lc3NhZ2VzJztcblxuY29uc3QgTG9hZGluZ1NwaW5uZXIgPSAoeyBpc0xvYWRpbmcgfSkgPT4ge1xuICBpZiAoIWlzTG9hZGluZykge1xuICAgIHJldHVybiBudWxsO1xuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNsYXNzTmFtZT1cInRleHQtY2VudGVyXCI+XG4gICAgICA8U3Bpbm5lciBtZXNzYWdlPXtpbnRsLmZvcm1hdE1lc3NhZ2UobWVzc2FnZXMubG9hZGluZ19tZXNzYWdlKX0gLz5cbiAgICA8L2Rpdj4pO1xufTtcblxuTG9hZGluZ1NwaW5uZXIucHJvcFR5cGVzID0ge1xuICBpc0xvYWRpbmc6IFByb3BUeXBlcy5ib29sLFxufTtcblxuTG9hZGluZ1NwaW5uZXIuZGVmYXVsdFByb3BzID0ge1xuICBpc0xvYWRpbmc6IGZhbHNlLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTG9hZGluZ1NwaW5uZXI7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner/LoadingSpinner.jsx
// module id = 345
// module chunks = 0